import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// import { AuthenticationService } from '../../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router
        // private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        //const currentUser = this.authenticationService.currentUserValue;
        //console.log("currentUser1 =====> ", currentUser, " state =====> ", state, " route =====> ", route);
        const access_token = localStorage.getItem('access_token');
        if (access_token) {
            // logged in so return true
            return true;
        } else{
        // not logged in so redirect to login page with the return url
        this.router.navigate(["/login"]);
        return false;
        }

    }
}